import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_12.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/talent');
  const shareText = encodeURIComponent('Talent Acquisition That Reflects Our Culture and Values!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Talent Acquisition — Outstanding Workplaces</title>
        <meta property="og:title" content="Talent Acquisition — Outstanding Workplaces" />
        <meta property="og:description" content="Talent Acquisition That Reflects Our Culture and Values" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778044355/i_12_aybnik.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/talent" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Talent Acquisition — Outstanding Workplaces" />
        <meta name="twitter:description" content="Talent Acquisition That Reflects Our Culture and Values" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778044355/i_12_aybnik.jpg" />
      </Helmet>

                     
   <div className="sight_12_page_wrapper">
      <div className="sight_12_content_container">

        <div className="sight_12_section_one">

          {/* TITLE */}
          <h1 className="sight_12_page_title">
            Talent Acquisition That Reflects Our Culture and Values
          </h1>

          {/* ROW */}
          <div className="sight_12_row">

            {/* LEFT SIDE */}
            <div className="sight_12_left">
              <div className="sight_12_image_wrapper">
                <img
                  src="/assets/i_12.jpg"
                  alt="Team meeting discussion"
                  className="sight_12_blog_image"
                />
              </div>




                {/* SHARE SECTION */}
                <div className="sight_12_share_section">
                  <span className="sight_12_share_text">Share :</span>
                  <div className="sight_12_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_12_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_12_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_12_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_12_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

               <p className="sight_12_intro_paragraph">
                A strong talent acquisition strategy is not just about filling roles—it’s a core part of employer branding. How a company attracts, engages, and hires talent directly shapes how potential candidates perceive the organization.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_12_right">
              <div className="sight_12_ad_card">
                <img src="/assets/bc_1.png" className="sight_12_ad_bg" />
                <div className="sight_12_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_12_ad_badge" />

                <div className="sight_12_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_12_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ✅ UPDATED SECTION TWO */}
        <div className="sight_12_section">
          <ul className="sight_12_bullet_list">

            <li>Building a Strong Employer Brand to Attract Top Talent</li>
            <li>How a compelling employer brand makes recruitment easier and attracts high-quality candidates.</li>

            <li>The Role of Candidate Experience in Employer Branding</li>
            <li>Steps to ensure every touchpoint during hiring reflects the company’s culture and values.</li>

            <li>Leveraging Social Media for Talent Acquisition</li>
            <li>Using LinkedIn, Instagram, and other platforms to showcase workplace culture and engage potential hires.</li>

            <li>How Employer Branding Shapes Your Talent Acquisition Strategy</li>
            <li>Aligning recruitment campaigns with EVP, company culture, and brand messaging.</li>

            <li>Employee Advocacy: Turning Employees into Brand Ambassadors</li>
            <li>Encouraging employees to share experiences and success stories to boost talent attraction.</li>

            <li>Diversity and Inclusion in Recruitment: Strengthening Your Brand</li>
            <li>Demonstrating commitment to inclusive hiring practices enhances employer credibility.</li>

            <li>Recruitment Marketing: Promoting Your Employer Brand</li>
            <li>Strategies for campaigns, job postings, and events that highlight what makes the company unique.</li>

            <li>Onboarding as a Talent Acquisition Tool</li>
            <li>How a strong onboarding experience reinforces the employer brand and increases retention.</li>

            <li>Measuring the Impact of Employer Branding on Recruitment</li>
            <li>Metrics to track how brand perception affects applications, quality of hire, and retention.</li>

            <li>Future-Proofing Talent Acquisition Through Employer Branding</li>
            <li>Emerging trends like AI-driven recruitment and storytelling to strengthen your brand for the next generation of talent.</li>

          </ul>
        </div>

      </div>
   </div>
    </>
  );
}

export default BlogPage;

